import React, { createContext, useContext } from 'react';
interface VideoCopilotContextValue {
  scheduleId?: string;
  contentId?: string;
  khazanaProgramId?: string;
  batchSlug?: string;
  type?: string;
  src?: string;
  isUnderMaintenance?: boolean;
  showProducts?: boolean;
  defaultMuted?: boolean;
  entryPoint?: string;
  videoId?: string;
  vType?: string;
  playlistId?: string;
}

const VideoCopilotContext = createContext<VideoCopilotContextValue>({
  scheduleId: '',
  contentId: '',
  khazanaProgramId: '',
  batchSlug: '',
  type: '',
  src: '',
  isUnderMaintenance: false,
  showProducts: false,
  defaultMuted: false,
  entryPoint: '',
  videoId: '',
  vType: '',
  playlistId: '',
});

export const VideoCopilotProvider: React.FC<{
  children: React.ReactNode;
  scheduleId?: string;
  contentId?: string;
  khazanaProgramId?: string;
  batchSlug?: string;
  type?: string;
  src?: string;
  isUnderMaintenance?: boolean;
  showProducts?: boolean;
  defaultMuted?: boolean;
  entryPoint?: string;
  videoId?: string;
  vType?: string;
  playlistId?: string;
}> = ({
  children,
  scheduleId,
  contentId,
  khazanaProgramId,
  batchSlug,
  type,
  src,
  isUnderMaintenance,
  showProducts,
  defaultMuted,
  entryPoint,
  videoId,
  vType,
  playlistId,
}) => {
  const contextValue: VideoCopilotContextValue = {
    scheduleId,
    contentId,
    khazanaProgramId,
    batchSlug,
    type,
    src,
    isUnderMaintenance,
    showProducts,
    defaultMuted,
    entryPoint,
    videoId,
    vType,
    playlistId,
  };

  return (
    <VideoCopilotContext.Provider value={contextValue}>{children}</VideoCopilotContext.Provider>
  );
};

export const useVideoCopilot = (): VideoCopilotContextValue => {
  const context = useContext(VideoCopilotContext);
  if (!context) {
    console.error(
      'useVideoCopilot must be used within a VideoCopilotProvider. Make sure the component is wrapped with VideoCopilotProvider.',
    );
    throw new Error('useVideoCopilot must be used within a VideoCopilotProvider');
  }
  return context;
};
